import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isActiveDevice: false,
    currentDevice: null,
}

const deviceSlice = createSlice({
    name: 'device',
    initialState,
    reducers: {
        fetchingDeviceSuccess: (state, action) => {
            state.isActiveDevice = true;
            state.currentDevice = action.payload;
        },
        fetchingDeviceReset: (state) => {
            state.isActiveDevice = false;
            state.currentDevice = null;
        },
    }
});

export const { fetchingDeviceSuccess, fetchingDeviceReset } = deviceSlice.actions;

export default deviceSlice.reducer;